import React from 'react';
import PropTypes from 'prop-types';


import {useI18nMessage} from '../../../contexts/I18n';

import styles from './SupportLink.scss';


function SupportLink({subject}) {

    const supportMessage = useI18nMessage('support.mail.link');

    return (
        <a
            aria-label={supportMessage}
            className={styles.contactUsLink}
            href={`mailto:support@journexx.com?subject=${subject}`}
        >
            {supportMessage}
        </a>
    );
}


SupportLink.propTypes = {
    message: PropTypes.string,
    subject: PropTypes.string.isRequired
};

SupportLink.defaultProps = {
    subject: 'Support'
};


export default SupportLink;
